
export default {
    name: "displayModule",
    data(){
        return {
            goodsList:[]
        }
    },
    props: {
        goodsUnionNo:{
            type: [Number,String],
            default: null
        },
        goodsNo:{
            type: [Number,String],
            default: null
        },
    },
    methods: {
        async getBindConjoinedGoods(){
            const res = await this.$api.unionBindListApi({goodsNo:this.goodsNo,goodsUnionNo:this.goodsUnionNo})
            if(!res.success){
                return this.$message.error(res.info)
            }
            this.goodsList = res.data
        },
        onCheckDetails(goods){
            this.$router.push(`/goodsDetails/${goods.goodsNo}/${goods.goodsCatalogueId}?from=${encodeURIComponent('商品详情页（连体号场景）')}`)
        }
    },
    mounted() {
        this.getBindConjoinedGoods()
    }
}
